import { parseOauth2Config } from './Oauth2Configuration';
import { parseServiceConfig } from './ServiceConfiguration';
import { parseProductConfig } from './ProductConfiguration';
import { parseObjectStorageConfig } from './ObjectStorageConfiguration';
import FetchClient from '@cb/common-ts/FetchClient';
export async function fetchAndParseConfiguration() {
    const config = await fetchConfiguration();
    const oauth2Config = parseOauth2Config(config);
    const serviceConfig = parseServiceConfig(config);
    const productConfig = parseProductConfig(config);
    const objectStorageConfig = parseObjectStorageConfig(config);
    return {
        oauth2Config,
        serviceConfig,
        productConfig,
        objectStorageConfig,
    };
}
export function fetchConfiguration() {
    const fetchClient = new FetchClient();
    const request = fetchClient.getJson('/config/config.json');
    return request.response;
}
//# sourceMappingURL=Configuration.js.map